export default __webpack_public_path__ + "static/media/addProductStart.622153d3.png";